import { render, staticRenderFns } from "./recipe-grid-filter-app.vue?vue&type=template&id=4576ccc8&"
import script from "./recipe-grid-filter-app.vue?vue&type=script&lang=js&"
export * from "./recipe-grid-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports